/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CoreComponentEventNodeTypes } from "../ui";

export class ComponentEventResolver {
	public getEventNodeTypes(): unknown {
		return CoreComponentEventNodeTypes;
	}

	public getEventHandler(): void {
		throw new Error("Not supported on server-side.");
	}
}
